import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import { Easing, Tween } from '@tweenjs/tween.js';
import {
    AwaitIterators,
    ConcatIterators,
    PlayAnimation,
} from '../AnimationHelper';
import { delay } from '../../../Utility/Task/TaskQueue';
import { tVector4 } from '../../../Utility/ArrayHelper';
import Armature from '../../../Prototype/Armature';
import { DragonbonesDefault } from './DragonbonesDefault';
import TransformComponent from 'Component/Transform';

interface IQuestItemCompleteOutroMeta {
    initialDelay: number;
    button: GameObject;
    activeContainer: GameObject;
    completeContainer: GameObject;
    completeText: GameObject;
    check: Armature;
}
export class QuestItemCompleteOutro extends AnimationClip<
    IQuestItemCompleteOutroMeta
> {
    public *execute(
        gameObject: GameObject,
        meta?: IQuestItemCompleteOutroMeta
    ): IterableIterator<number> {
        const buttonRenderable: Renderable = meta.button.getComponent(
            Renderable
        );
        const activeContainerRenderable: Renderable = meta.activeContainer.getComponent(
            Renderable
        );
        const completeTextRenderable: Renderable = meta.completeText.getComponent(
            Renderable
        );
        const completeTextTransform: TransformComponent = meta.completeText.getComponent(
            TransformComponent
        );
        const gameObjectTransform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        yield* this.startTween(
            this.getTween(gameObjectTransform.scale).to({ x: 1, y: 1 }, 50)
        );

        yield* delay(meta.initialDelay);

        // Hide active container and button, show complete container
        yield* AwaitIterators([
            this.startTween(
                this.getAlphaTween(activeContainerRenderable, 0, 450)
            ),
            this.startTween(this.getAlphaTween(buttonRenderable, 0, 250)),
        ]);

        buttonRenderable.visible = false;

        yield* AwaitIterators([
            ConcatIterators([
                delay(150),
                // Slide/fade in text
                AwaitIterators([
                    this.startTween(
                        this.getAlphaTween(completeTextRenderable, 1, 450)
                    ),
                    this.startTween(
                        this.getPositionXTween(
                            completeTextTransform,
                            0,
                            350
                        )
                    ),
                ]),
                // Wait for check mark to animate
                delay(950),
                // Slide/fade out text
                AwaitIterators([
                    this.startTween(
                        this.getAlphaTween(completeTextRenderable, 0, 450)
                    ),
                    this.startTween(
                        this.getPositionXTween(
                            completeTextTransform,
                            100,
                            450
                        )
                    ),
                ]),
            ]),
            this.playCheckAnimation(meta.check, 0),
        ]);
        yield* delay(150);
    }

    private getAlphaTween(
        renderable: Renderable,
        alpha: number,
        duration: number = 250,
        easing: (k: number) => number = Easing.Exponential.InOut
    ): Tween {
        return this.getTween(renderable)
            .to({ alpha }, duration)
            .easing(easing);
    }
    private getPositionXTween(
        transform: TransformComponent,
        x: number,
        duration: number = 250,
        easing: (k: number) => number = Easing.Quadratic.Out
    ): Tween {
        return this.getTween(transform)
            .to({ x }, duration)
            .easing(easing);
    }
    private *playCheckAnimation(
        gameObject: Armature,
        initialDelay: number
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        yield* delay(initialDelay);
        yield* AwaitIterators([
            PlayAnimation(
                new DragonbonesDefault(gameObject, {
                    playTimes: 1,
                })
            ),
            this.startTween(this.getAlphaTween(renderable, 1, 50)),
        ]);
    }
}
